<template>
  <section class="container">
    <div class="content">
      <div class="row w-100 mb-4">
        <div class="col-12 pl-3 px-0 mb-0 text-left">
          <BreadCrumbComponent :pageTitles="['Lectures']" />
        </div>
      </div>
      <div class="row w-100">
        <div class="col-12 text-left">
          <div
            style="
              font-size: 20px;
              font-weight: 400;
              color: var(--el-app-primary);
              margin-bottom: 15px;
            "
          >
            <strong>My Lectures</strong>
          </div>
        </div>
      </div>
      <UpcomingLecturesComponent />
      <div class="row w-100 mt-3">
        <div class="col-12 text-left" style="font-weight: 600">
          All Lectures Time Table
        </div>
        <div
          class="col-12 text-left mt-4"
          style="font-weight: 400; font-size: 0.9em"
        >
          To view all Lectures including those you attended or missed already.
          Press the button below
        </div>
        <div class="col-12 pl-2 mt-1 text-left">
          <button
            type="button"
            class="btn z-depth-0"
            @click="
              $router.push({ path: '/dashboard/my-calendar' })
            "
            v-ripple="'rgba(255, 255, 255, 0.35)'"
            style="
              width: 140px;
              text-transform: capitalize;
              height: 40px;
              border-radius: 4px;
              background-color: var(--el-app-primary);
            "
          >
            <span style="position: relative; bottom: 4px">View All </span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import UpcomingLecturesComponent from "@/components/upcoming-lectures-component.vue";
import BreadCrumbComponent from "../components/bread-crumb-component";
export default {
  components: {
    BreadCrumbComponent,
    UpcomingLecturesComponent,
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.content {
  margin-top: 45px !important;
}
.ui-margin {
  margin-left: 42px !important;
  margin-right: 42px !important;
}

@media (max-width: 768px) {
  .content {
    margin-top: 15px !important;
  }
}
</style>


<style>
th > .cell {
  color: rgba(0, 0, 0, 0.836) !important;
  font-weight: 600 !important;
  font-size: 13px !important;
}
el-table th > .cell {
  color: black !important;
  font-weight: 500;
}
.el-table .cell {
  font-size: 0.9em;
  line-height: 23px;
  font-weight: 300;
}
</style>